module.exports = __webpack_public_path__ + "assets/wedoselling.03b5cf58ae40b45afac1cbb64e22b95e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/wedoselling.png
 ** module id = 379
 ** module chunks = 0
 **/